import { render } from "./Vehicles.vue?vue&type=template&id=f0f79210&scoped=true"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"

import "./Vehicles.vue?vue&type=style&index=0&id=f0f79210&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f0f79210"

export default script